import AttachmentModel from 'owa-attachment-model-store/lib/store/schema/AttachmentModel';
import { isBefore, now } from 'owa-datetime';

export function isAttachmentExpired(attachment: AttachmentModel): boolean {
    return (
        attachment?.info?.sharingInfo?.expirationDate &&
        isBefore(attachment.info.sharingInfo.expirationDate, now())
    );
}
